import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  ApprovalRequest,
  ApprovalReviewDialogPayload,
  ApprovalReviewProgressPayload,
  ApprovalState,
} from '@/entities/approval';

const initialState: ApprovalState = {
  reviewDialog: {
    open: false,
    mode: null,
    request: null,
    reviewingRequestId: null,
    reviewingMode: null,
  },
  creativeDetailsModal: {
    open: false,
    request: null,
  },
  screenDetailsModal: {
    open: false,
    request: null,
  },
  campaignDetailsModal: {
    open: false,
    request: null,
  },
};

const approvalSlice = createSlice({
  name: 'approval',
  initialState,
  reducers: {
    openApprovalReviewDialog: (
      state,
      action: PayloadAction<ApprovalReviewDialogPayload>
    ) => {
      state.reviewDialog.open = true;
      state.reviewDialog.mode = action.payload.mode;
      state.reviewDialog.request = action.payload.request;
      state.reviewDialog.reviewingRequestId = null;
      state.reviewDialog.reviewingMode = null;
    },
    closeApprovalReviewDialog: state => {
      state.reviewDialog.open = false;
      state.reviewDialog.mode = null;
      state.reviewDialog.request = null;
      state.reviewDialog.reviewingRequestId = null;
      state.reviewDialog.reviewingMode = null;
    },
    startApprovalReview: (
      state,
      action: PayloadAction<ApprovalReviewProgressPayload>
    ) => {
      state.reviewDialog.reviewingRequestId = action.payload.requestId;
      state.reviewDialog.reviewingMode = action.payload.mode;
    },
    finishApprovalReview: state => {
      state.reviewDialog.reviewingRequestId = null;
      state.reviewDialog.reviewingMode = null;
    },
    openCreativeApprovalDetailsModal: (
      state,
      action: PayloadAction<ApprovalRequest>
    ) => {
      state.creativeDetailsModal.open = true;
      state.creativeDetailsModal.request = action.payload;
    },
    closeCreativeApprovalDetailsModal: state => {
      state.creativeDetailsModal.open = false;
      state.creativeDetailsModal.request = null;
    },
    openScreenApprovalDetailsModal: (
      state,
      action: PayloadAction<ApprovalRequest>
    ) => {
      state.screenDetailsModal.open = true;
      state.screenDetailsModal.request = action.payload;
    },
    closeScreenApprovalDetailsModal: state => {
      state.screenDetailsModal.open = false;
      state.screenDetailsModal.request = null;
    },
    openCampaignApprovalDetailsModal: (
      state,
      action: PayloadAction<ApprovalRequest>
    ) => {
      state.campaignDetailsModal.open = true;
      state.campaignDetailsModal.request = action.payload;
    },
    closeCampaignApprovalDetailsModal: state => {
      state.campaignDetailsModal.open = false;
      state.campaignDetailsModal.request = null;
    },
  },
});

export const {
  openApprovalReviewDialog,
  closeApprovalReviewDialog,
  startApprovalReview,
  finishApprovalReview,
  openCreativeApprovalDetailsModal,
  closeCreativeApprovalDetailsModal,
  openScreenApprovalDetailsModal,
  closeScreenApprovalDetailsModal,
  openCampaignApprovalDetailsModal,
  closeCampaignApprovalDetailsModal,
} = approvalSlice.actions;

export default approvalSlice.reducer;
